import { divide } from "lodash";

export const ROLE = {
  ADMIN: "admin",
  STAFF: "staff",
  CLIENT: "client",
  HS_ADMIN: "admin_home_system",
  HS_STAFF: "staff_home_system",
};
export const PREFECTURE = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
];

export const EVENT_STATUS = {
  not_assign: {
    className: "info",
    bg: "rgba(115, 103, 240, 0.12)",
    color: "#7367f0",
  },
  not_enough_assign: {
    className: "error",
    color: "#f64747",
    bg: "rgba(247, 71, 71, 0.12)",
  },
  assigned: {
    className: "success",
    bg: "rgba(40, 199, 111, 0.12)",
    color: "#28c76f",
  },
};

export const CARE_PLAN_TYPE_OPTIONS = [
  {
    value: "NursingCarePlan",
    content: "介護",
  },
  {
    value: "DisabilityCarePlan",
    content: "障害",
  },
];

export const SHIFT_TYPES = {
  rarely: {
    value: "rarely",
    color: "#1b1b1b",
    label: "希休",
    border: "#4d4d4d",
  },
  day_off: {
    value: "day_off",
    color: "#d82121",
    label: "休",
    border: "#be1e1d",
  },
  early_shift: {
    value: "early_shift",
    color: "#9747ff",
    label: "早",
    border: "#853fe0",
  },
   day_shift_1: {
    value: "day_shift_1",
    color: "#b37feb",
    label: "日1",
    border: "#9d71ce",
  },
  late_shift: {
    value: "late_shift",
    color: "#e36dc9",
    label: "遅",
    border: "#c761b1",
  },
  night_shift: {
    value: "night_shift",
    color: "#00870d",
    label: "夜",
    border: "#00780b",
  },
  afternoon_shift: {
    value: "afternoon_shift",
    color: "#ea7e2c",
    label: "明",
    border: "#ce7027",
  },
  day_shift: {
    value: "day_shift",
    color: "#2c3e50",
    label: "日",
    border: "#1a2b3c",
  },
  day_shift_2: {
    value: "day_shift_2",
    color: "#5d5fef",
    label: "日2",
    border: "#5254d2",
  },
  day_shift_3: {
    value: "day_shift_3",
    color: "#000e96",
    label: "日3",
    border: "#000d84",
  },
  day_shift_4: {
    value: "day_shift_4",
    color: "#0066ff",
    label: "日4",
    border: "#3399ff",
  },
  day_shift_5: {
    value: "day_shift_5",
    color: "#004d00",
    label: "日5",
    border: "#007700",
  },
  required: {
    value: "required",
    color: "#eb2f96",
    label: "要",
    border: "#ce2a84",
  },
  symbol_o: {
    value: "symbol_o",
    color: "#660000",
    label: "○",
    border: "#990000",
  },
  symbol_x: {
    value: "symbol_x",
    color: "#800080",
    label: "×",
    border: "#a000a0",
  },
  early: {
    value: "early",
    color: "#F43F5E",
    label: "早遅",
    border: "#ec90a0",
  },
  paid_leave: {
    value: "paid_leave",
    color: "#4a148c",
    label: "有給",
    border: "#6a1b9a",
  },
};

export const SERVICE_CONTENTS = {
  inHomeCare: "居宅介護",
  serviceHomeVisitNursingCare: "重度訪問介護",
};

export const EMPLOYMENT_TYPE_OPTIONS = [
  {
    label: "社員",
    value: "full_time",
  },
  {
    label: "パート1",
    value: "part_time_1",
  },
  {
    label: "パート2",
    value: "part_time_2",
  },
  {
    label: "未定",
    value: "undecided",
  },
];